// Arabic translations (العربية)
import type { TranslationKeys } from './en';

export const ar: TranslationKeys = {
  // Common
  common: {
    home: 'الرئيسية',
    settings: 'الإعدادات',
    language: 'اللغة',
    loading: 'جاري التحميل...',
    save: 'حفظ',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    close: 'إغلاق',
    back: 'Back',
    continue: 'Continue',
    accept: 'Accept',
    decline: 'Decline',
    contactEmail: 'contact@zodiac-chess.com',
    companyName: 'Animal Chess Limited',
    companyCountry: 'New Zealand',
  },

  // Settings Menu
  settings: {
    header: 'الإعدادات',
    home: 'الرئيسية',
    howToPlay: 'كيفية اللعب',
    pieceRules: 'قواعد القطع',
    language: 'اللغة',
    manageSubscription: 'إدارة الاشتراك',
    gameHistory: 'تاريخ اللعبة',
    analytics: 'التحليلات',
    premiumAccount: 'حساب مميز',
    chatEnabled: 'الدردشة: مفعلة',
    chatDisabled: 'الدردشة: معطلة',
  },

  // Piece Rules
  pieceRules: {
    title: 'قواعد القطع',
    description: 'تعلم حركة القطع',
    selectPiece: 'اختر القطعة',
    selectedLabel: 'المحدد:',
    statusLabel: 'الحالة:',
    statusReady: 'جاهز',
    statusViewing: 'المشاهدة',
    movement: 'الحركة',
    regularMovement: 'الحركة العادية',
    ability: 'القدرة',
      backToSelection: 'Back to selection',
    backToHome: 'Back to home',
  },

  // Move/Ability Names
  moves: {
    movement: 'الحركة',
    savage: 'متوحش',
    birdtype: 'نوع الطائر',
    birdType: 'نوع الطائر',
    wallBlock: 'حاجز الحائط',
    moveblocks: 'حواجز الحركة',
    wallclimb: 'تسلق الحائط',
    lilypad: 'ورقة اللوتس',
    poisonous: 'سام',
    meadow: 'المرج',
    parasiticfungi: 'فطر طفيلي',
    zombification: 'التحول لزومبي',
    fungi: 'فطر',
    traverse: 'عبور',
    capture: 'أسر',
    faint: 'إغماء',
    leap: 'قفز',
    swing: 'تأرجح',
    consume: 'استهلاك',
    gamble: 'مقامرة',
    entangle: 'تشابك',
    ink: 'حبر',
    rotate: 'دوران',
    backstep: 'خطوة للخلف',
    trample: 'دوس',
    charge: 'هجوم',
    lane: 'مسار',
    snakestrike: 'ضربة الثعبان',
    shedskin: 'تبديل الجلد',
    house: 'منزل',
    plant: 'نوع النبات',
    planttype: 'نوع النبات',
    capturehost: 'أسر المضيف',
    contagion: 'عدوى',
    lonewolf: 'الذئب الوحيد',
    hop: 'قفزة',
    decay: 'تحلل',
    slide: 'انزلاق',
    block: 'حظر',
    poison: 'سم',
    infection: 'عدوى',
    howl: 'عواء',
  },

  // Animation Scenario Descriptions
  scenarios: {
    // Bear
    bearMovement: 'يمكن للدب التحرك مربعاً واحداً في أي اتجاه، مثل الملك في الشطرنج',
    bearMovementPost: 'يتم حظره فقط بواسطة القطع الصديقة (باستثناء الأشجار، الدببة يمكنها تسلق الأشجار!)',
    bearSavage: 'يمكن للدب التغلب على القدرات الدفاعية مثل حظر وحيد القرن',
    bearSavagePost: 'باستخدام المتوحش، يمكن للدب أسر أي قطعة من أي اتجاه، مما يضيف الفتك',

    // Crane
    craneMovement: 'يمكن للكركي التحرك 1 أو 2 مربع في أي خط مستقيم',
    craneMovementPost: 'يمكن للكركي حتى الطيران فوق القطع الأخرى!',
    craneBirdType: 'قطع نوع الطائر لا يمكنها أسر القطع الكبيرة أو المفترسة',
    craneBirdTypePost: 'وهذا يشمل الأشجار ووحيد القرن والدب والذئب',

    // Frog
    frogMovement: 'يقفز الضفدع مربعين قطرياً',
    frogMovementPost: 'لا يمكنه القفز مربعاً واحداً فقط',
    frogWallBlock: 'إذا تم حظر مسار الضفدع العادي المكون من مربعين بواسطة حائط أو قطعة أخرى، فلا يمكنه الأسر',
    frogWallBlockPost: 'تقصر الحركة العادية إلى مربع واحد قطرياً',
    frogWallClimb: 'عندما يكون الضفدع على حائط اللوحة (العمود A أو E) يمكنه التحرك مربعاً واحداً لأعلى أو لأسفل',
    frogWallClimbPost: 'ما لم يكن محظوراً بواسطة قطع صديقة أو وحيد قرن أمام الضفدع',
    frogLilypad: 'إذا لم يتحرك الضفدع بعد في اللعبة، فيمكنه الذهاب إلى أي مكان ضمن أول 3 صفوف، قدرة دفاعية قوية',
    frogLilypadPost: 'يمكن استخدام قفزة ورقة اللوتس لأسر القطع العادية، باستثناء وحيد القرن الذي يكون في رتبة أعلى منه',
    frogPoisonous: 'إذا أسر حيوان قطعة الضفدع، فإنهم يصبحون مسمومين!',
    frogPoisonousPost: 'تتخطى القطعة المسمومة دورها الممكن التالي قبل التعافي',

    // Fungi
    fungiMovement: 'يمكن للفطر التحرك مربعاً واحداً في أي اتجاه',
    fungiMovementPost: 'محظور فقط بواسطة القطع الصديقة',
    fungiMeadow: 'يقلل الفطر من قدرة حركة قطع الأشجار المعادية',
    fungiMeadowPost: 'لا يمكن لقطع الأشجار المعادية التحرك ضمن مربع واحد من قطعة الفطر',
    fungiParasitic: 'يمكن للفطر تثبيت قطع الأشجار المعادية',
    fungiParasiticPost: 'عندما يكون الفطر ضمن مربع واحد من شجرة معادية، لا يمكنها التحرك حتى يبتعد الفطر أو يتم أسره',
    fungiZombification: 'يمكن للفطر تحويل قطعة الحيوان المعادي الذي يأسره إلى زومبي، للتحكم في الحيوان المعادي لدور واحد',
    fungiZombificationPost: 'تعتبر القطعة المحولة أيضاً قطعة فطر لذلك الدور، وإذا كان الفطر ملكاً فلن تنتهي اللعبة حتى نهاية ذلك الدور',
    fungiFungi: 'الفطر',
    fungiFungiPost: 'مثل السم والتشابك وعدوى الفيروس، على الرغم من أن التحويل لزومبي استثناء لأن الزومبي يمكنه تحويل الآخرين!',

    // Goat
    goatMovement: 'يمكن للماعز التحرك مربعاً واحداً في أي اتجاه',
    goatMovementPost: 'الماعز بطيء الحركة ولكن لديه قدرات قوية',
    goatTraverse: 'يمكن للماعز عبور القطع الأخرى المتصلة مما يخلق إمكانات حركة هائلة',
    goatTraversePost: 'لا يمكن للماعز عبور القطع الصغيرة مثل الماعز المغمى عليه أو الفيروس',
    goatCapture: 'لا يمكن للماعز أسر المفترسات',
    goatCapturePost: 'مثل الدب أو الذئب',
    goatFaint: 'يمكن للماعز الإغماء لتجنب الأسر باستثناء القطع الكبيرة مثل الأشجار ووحيد القرن',
    goatFaintPost: 'أثناء الإغماء، يمكن للخصم "الوقوف" فوق الماعز المغمى عليه لحظر الحركة',

    // Monkey
    monkeyMovement: 'يمكن للقرد التحرك مربعاً واحداً في أي اتجاه',
    monkeyMovementPost: 'بدون قطع أخرى للاستفادة منها، القرد محدود الحركة',
    monkeyLeap: 'يمكن للقرد القفز فوق القطع الأخرى في خط مستقيم مثل لعبة الداما مما يمنح إمكانات حركة هائلة',
    monkeyLeapPost: 'لكن القفز فوق قطع العدو يجعل القرد يدحرج النرد للبقاء على قيد الحياة، مع فرصة 1/6 للأسر لكل عدو يقفز فوقه!',
    monkeySwing: 'عندما يقفز القرد فوق شجرة يحصل على دور إضافي',
    monkeySwingPost: 'استخدام التأرجح على الشجرة يخلق كومبو تآزري قوي بين القرد وقطع الشجرة',
    monkeyConsume: 'يمكن للقرد استهلاك قطعة الفطر والحصول على دور إضافي',
    monkeyConsumePost: 'عند دمجه مع الأدوار الإضافية الأخرى يؤدي إلى كومبو مدمر',
    monkeyGamble: 'بالإضافة إلى دحرجة النرد للقفز فوق الأعداء، يجب على القرد المقامرة لأسر الدب',
    monkeyGamblePost: 'يجب على القرد دحرجة 5 أو 6 على نرد من 6 جوانب لأسر الدب، وإلا سيتم أسره',

    // Octopus
    octopusMovement: 'يتحرك الأخطبوط مربعاً واحداً في أي اتجاه',
    octopusCapture: 'يمكن للأخطبوط الأسر فقط بزوايا قائمة',
    octopusCapturePost: 'يمكن للأخطبوط أسر أو تشابك القطع بطرق معقدة، لذا تحقق دائماً من الأسر الأحمر والتشابك البنفسجي!',
    octopusEntangle: 'يمكن للأخطبوط تشابك قطع العدو القريبة التي تثبتها، ويمكنه تشابك الأعداء بالتحرك مربعاً واحداً!',
    octopusEntanglePost: 'لا يمكن للقطعة المتشابكة التحرك حتى يبتعد الأخطبوط أو يتم أسره',
    octopusInk: 'يمكن للأخطبوط استخدام الحبر للهروب من المواقف الخطرة وإنشاء ما يصل إلى 3 ظلال',
    octopusInkPost: 'إرباك الأعداء وتمكين ألعاب الطعم والمراوغة المثيرة',

    // Penguin
    penguinMovement: 'ينزلق البطريق في خط مستقيم في الاتجاه المحدد ويستمر حتى يوقف حائط أو قطعة الحركة',
    penguinMovementPost: 'بعد الحركة، يمكن للبطريق أيضاً تعيين اتجاهه النهائي ضمن نفس الدور',
    penguinRotate: 'في بداية المباراة، يكون البطريق متجهاً للأسفل ويجب أن يدور قبل الانزلاق، يسمى أيضاً بالنوم',
    penguinRotatePost: 'يمكن للبطريق اختيار الدوران بدلاً من الحركة من أي موضع',
    penguinBirdType: 'البطريق لديه قدرات أسر محدودة مثل الكركي، ولا يمكنه أسر القطع الكبيرة أو المفترسة مثل الأشجار ووحيد القرن والدب والذئب',
    penguinBirdTypePost: 'بعد الأسر، يمكن للبطريق الدوران في أي اتجاه للوضع الاستراتيجي',

    // Rhino
    rhinoMovement: 'يتحرك وحيد القرن مربعين للأمام فقط',
    rhinoMovementPost: 'لا يمكنه التحرك مربعاً واحداً فقط',
    rhinoBackStep: 'يمكن لوحيد القرن التحرك للخلف الأيسر أو الخلف الأيمن',
    rhinoCharge: 'يمكن لوحيد القرن استخدام قدرة الهجوم مرة واحدة في اللعبة مما يسمح له بالتحرك مربعاً إضافياً للأمام',
    rhinoChargePost: 'يؤدي إلى حركة مدمرة وإمكانات أسر',
    rhinoTrample: 'يأسر وحيد القرن جميع القطع في طريقه عن طريق الدوس',
    rhinoTramplePost: 'بما في ذلك قطع الماعز المغمى عليها',
    rhinoLane: 'يمكن لوحيد القرن تبديل الأماكن مع قطع صديقة أخرى للعب المسار الاستراتيجي',
    rhinoLanePost: 'ولكن فقط إذا لم يتحرك كل من وحيد القرن والقطعة الصديقة',

    // Snake
    snakeMovement: 'يمكن للثعبان التحرك مربعين في خط مستقيم',
    snakeMovementPost: 'يتحرك الثعبان بالضبط مربعين ما لم يكن محظوراً بواسطة حائط أو قطع صديقة',
    snakeMoveBlocks: 'إذا تم حظره بواسطة حائط أو قطعة غير قابلة للأسر، تقصر حركة الثعبان إلى مربع واحد',
    snakeMoveBlocksPost: 'لا يزال بإمكانه التحرك مربعين حتى مع قطع في المنتصف',
    snakeStrike: 'إذا كان هناك حيوان عدو، يمكن للثعبان الضرب حتى 3 مربعات للأمام',
    snakeStrikePost: 'ما لم تكن هناك قطع متوسطة تحظر الطريق',
    snakeShedskin: 'مرة واحدة في اللعبة، يمكن للثعبان تبديل الجلد والعودة إلى الصف الأول إذا كان المربع فارغاً',
    snakeShedskinPost: 'هذه الولادة الجديدة تمنح الثعبان حياة إضافية في كل لعبة',

    // Tree
    treeMovement: 'يمكن للشجرة التحرك مربعاً واحداً للأمام أو إلى أي مربع يساراً أو يميناً في نفس الصف',
    treeMovementPost: 'ما لم يكن الطريق محظوراً',
    treeHouse: 'يمكن للشجرة إيواء قطع أخرى لحمايتها من الأعداء الذين لا يمكنهم تسلق الشجرة. القطع التي يمكنها التسلق: الدب، الكركي، الضفدع، الفطر، الماعز، القرد، الأخطبوط، الثعبان',
    treeHousePost: 'إذا هاجمت قطعة يمكنها تسلق الشجرة، فإنها تأسر فقط القطعة المأواة، لحماية الشجرة',
    treeTrample: 'تأسر الشجرة جميع القطع في المربع عند التحرك إليه مثل وحيد القرن',
    treeTramplePost: 'بما في ذلك الماعز المغمى عليه',
    treePlant: 'الشجرة ليست حيواناً بل نبات، لذا فهي محصنة ضد العديد من التأثيرات',
    treePlantPost: 'مثل السم والتحويل لزومبي والتشابك وعدوى الفيروس!',

    // Virus
    virusMovement: 'يمكن للفيروس التحرك فقط إلى المربعات التي يشغلها حيوان على بعد مربعين',
    virusMoveBlocks: 'يمكن للفيروس التحرك مربعاً واحداً فقط عندما يكون بجوار حائط',
    virusCaptureHost: 'عندما يهبط الفيروس (يدخل) على قطعة حيوان، فإنه يصيب فقط، ويمكنه مواصلة اللعب العادي أثناء الإصابة',
    virusCaptureHostPost: 'يأسر الفيروس القطعة فقط عند مغادرة المضيف المصاب',
    virusContagion: 'يمكن للفيروس إصابة عدة مضيفين في دور واحد مما ينتشر بسرعة',
    virusContagionPost: 'من خلال العدوى، يمكن للفيروس القيام بأكبر عدد ممكن من الحركات القانونية في كل دور كما يريد',

    // Wolf
    wolfMovement: 'يمكن للذئب التحرك في شكل L مثل الفارس في الشطرنج',
    wolfMovementPost: 'غير معاق بواسطة القطع الأخرى',
    wolfLoneWolf: 'الذئب',
    wolfLoneWolfPost: 'يعتبر الذئب وحيداً إذا كان لديه فقط ماعز مغمى عليه أو أصدقاء فيروس',
  },

  // Tutorials
  tutorials: {
    dragToExploreMobile: '👆 اسحب للاستكشاف • اقرص للتكبير',
    dragToExploreDesktop: '🖱️ اسحب للاستكشاف • مرر للتكبير',
    previousConstellation: 'Previous constellation',
    nextConstellation: 'Next constellation',
    lockedNextHint: 'Complete at least 3 {constellation} tutorials to move to the next constellation',
    lockedStateLabel: 'Star Path',
    freeStateLabel: 'Free Roam',
    clickToFreeRoam: 'Click to free roam',
    clickForStarPath: 'Click for Star Path',
    // Tutorial popups
    failed: 'FAILED!',
    success: 'SUCCESS!',
    failedDefaultMessage: "Don't give up! Try a different approach.",
    superMessage: 'Perfect! You achieved Super completion!',
    passMessage: 'Well done! Tutorial completed!',
    tryAgain: 'Try Again',
    back: 'رجوع',
    next: 'التالي',
    backToDev: 'Back to Dev',
    backToTutorials: 'Back to Tutorials',
    continue: 'Continue',
    close: 'Close',
  },

  // Sandbox
  sandbox: {
    title: 'صندوق الرمل',
    description: 'التجربة والممارسة',
    mode: 'الوضع:',
    modeValue: 'صندوق الرمل',
    status: 'الحالة:',
    statusReady: 'جاهز',
    clearBoard: 'مسح اللوحة',
  },

  // Multiplayer
  multiplayer: {
    title: 'متعدد اللاعبين',
    description: 'ابحث عن خصوم وتنافس!',
    // Rematch
    rematchRequest: 'Rematch Request',
    rematchMessage: '{opponent} wants to play again!',

    // Placement matches
    placementMatches: 'مباريات التصنيف',
    matchProgress: 'تقدم المباراة',
    gamesCompleted: '{games} / 10 ألعاب مكتملة',
    estimatedFinalRating: 'التصنيف النهائي المقدر',
    startingRating: 'التصنيف الابتدائي',
    matchesRemaining: '{matches} مباريات متبقية',
    findPlacementMatch: 'ابحث عن مباراة تصنيف',

    // Matchmaking modes
    findMatch: 'ابحث عن مباراة',
    competitive: 'تنافسي',
    competitiveDesc: 'ابحث عن خصوم برتبة مماثلة',
    quick: 'مباراة سريعة',
    quickDesc: 'ابحث بسرعة عن مباراة تنافسية',
    casual: 'عادي',
    casualDesc: 'بدون تصنيف - العب من أجل المتعة!',
    placement: 'التصنيف',
    placementDesc: 'أكمل 10 مباريات للحصول على تصنيف',
    startSearch: 'ابدأ البحث',

    // Searching
    searching: 'البحث جاري...',
    mode: 'الوضع:',
    inQueue: 'في الطابور:',
    players: 'لاعب',
    playersPlural: 'لاعبون',
    cancelSearch: 'إلغاء البحث',

    // Game info
    status: 'الحالة:',
    ready: 'جاهز',
    selectingKing: 'اختيار الملك',
    placingPieces: 'وضع القطع',
    playing: 'اللعب',
    gameType: 'نوع اللعبة:',
    opponent: 'الخصم:',
    opponentElo: 'ELO الخصم:',
    unranked: 'غير مصنف',

    // Piece placement
    dragPieces: 'اسحب القطع إلى اللوحة',
    lightPieces: 'القطع الفاتحة (أنت)',
    darkPieces: 'القطع الداكنة (أنت)',

    // Waiting states
    waitingForOpponent: 'في انتظار الخصم...',
    waitingForKing: 'في انتظار اختيار الخصم للملك...',

    // Warnings
    invalidPlacement: 'موضع غير صالح',
    lightTurn: 'إنه دور اللاعب الفاتح!',
    darkTurn: 'إنه دور اللاعب الداكن!',
    onlyLightPieces: 'يمكنك وضع القطع الفاتحة فقط!',
    onlyDarkPieces: 'يمكنك وضع القطع الداكنة فقط!',
    mustPlaceOnRow: 'يجب وضع قطع {color} في الصف {row}!',

    // Chat
    chat: 'الدردشة',
    typeMessage: 'اكتب رسالة...',
    send: 'إرسال',
  },

  // Main Page
  mainPage: {
    title: 'شطرنج الحيوانات',
    subtitle: 'لعبة للبشر',
    playersOnline: 'اللاعبون على الإنترنت الآن',
    placement: 'التصنيف',
    placementProgress: 'التصنيف',
    challengeAI: 'تحدي الذكاء الاصطناعي',
    multiplayer: 'متعدد اللاعبين',
    sandbox: 'صندوق الرمل',
    tutorials: 'دروس تعليمية',
    shop: 'المتجر',
    collection: 'المجموعة',
    history: 'التاريخ',
    analytics: 'التحليلات',
    courses: 'الدورات',
    upgradeAccount: 'ترقية الحساب',
    signIn: 'تسجيل الدخول',
    playAsGuest: 'العب كضيف',
    welcomeBack: 'مرحباً بعودتك! عادة تلعب كـ',

    // Learn the Pieces section
    learnThePieces: 'تعلم القطع',

    // Learn the Rules section
    learnTheRules: 'تعلم القواعد',
    premiseTitle: 'المقدمة',
    premiseText: 'Zodiac هي بديل للشطرنج مع ملك مخفي من قائمة من 13 قطعة، اختر قائمتك الفريدة ثم اخدع خصمك واهزمه على لوحة 5x8',
    selectionTitle: 'الاختيار',
    selectionText: 'لبدء اللعبة، اختر ملكك سراً ثم تناوب مع خصمك لوضع 5 قطع لإنشاء واحد من أكثر من 500 مليار موضع بداية.',
    objectiveTitle: 'الهدف',
    objectiveText: 'اقرأ خصمك لأسر ملكه السري أو احصل على النصر بتحريك ملكك إلى الجانب الآخر من اللوحة!',
    competeTitle: 'تنافس',
    competeText: 'اختبر مهاراتك على السلم، طور تقنيات واستراتيجيات شخصية جديدة، وارتقِ في الرتب للعب ضد الأفضل!',
    fullRulesButton: 'انقر هنا للقواعد الرسمية الكاملة',

    // FAQ section
    faqTitle: 'الأسئلة الشائعة',
    faqQuestion1: 'ما هي فكرة Zodiac شطرنج؟',
    faqAnswer1: 'تم إلهام Zodiac شطرنج من كلمات Bobby Fischer حول الإلهام لإنشاء Chess960. أردنا توسيع فكرة محاربة الحفظ الميكانيكي والاحتفال بالحدس البشري في عمق لا يحصى!',
    faqQuestion2: 'لماذا نحتاج بديلاً للشطرنج',
    faqAnswer2: 'لا نحتاج! Zodiac لا يريد إبعاد الناس عن لعب الشطرنج! إنه خيار آخر له إيجابيات وسلبيات خاصة به، ونأمل أن تستمتع وتساعد في ضبط هذه اللعبة لتمكين اللعب الجديد',
    faqQuestion3: 'كيف تفوز في Zodiac شطرنج؟',
    faqAnswer3: 'يمكنك الفوز بثلاث طرق: أسر قطعة الملك المخفي للخصم، أو تحريك ملكك إلى الجانب الآخر من اللوحة، أو نفاد وقت خصمك في المباريات الموقوتة',
    faqQuestion4: 'هل هذا سؤال شائع؟',
    faqAnswer4: 'نعم، يمكنك رؤية جميع الأسئلة المدرجة في الأسئلة الشائعة وإذا أردت مزيداً من التفاصيل، انقر على السؤال ثم اقرأ التفاصيل مثل هذه التي تقرأها الآن',
    faqQuestion5: 'كم من الوقت تستغرق اللعبة النموذجية؟',
    faqAnswer5: 'كل لعبة مختلفة جداً! يمكن أن تنتهي بعض الألعاب في دورين ويمكن أن يستغرق البعض 30 دقيقة، عادة 5-15 دقيقة!',
    faqQuestion6: 'ماذا يحدث إذا لم يتمكن أحد من القيام بحركة قانونية؟',
    faqAnswer6: 'إذا لم يتمكن اللاعب من القيام بحركة قانونية (جمود)، تنتهي اللعبة بالتعادل. يمكن أن تنتهي اللعبة أيضاً بالتعادل من خلال التكرار (نفس حالة اللوحة 3 مرات) أو بالاتفاق المتبادل بين اللاعبين!',

    // About section
    aboutButton: 'حول',
    privacyPolicy: 'سياسة الخصوصية',
    developerInterface: 'واجهة المطور',
  },

  // About Modal
  about: {
    title: 'حول Zodiac',
    paragraph1: 'Zodiac هي لعبة لوحة تشبه الشطرنج تجمع بين عناصر اختيار القطع من ألعاب مثل LoL و DotA مع آليات الخداع من البوكر أو ألعاب الاستنتاج الاجتماعي.',
    paragraph2: 'تم إنشاء النسخة الأولى من اللعبة في عام 2014 باسم Shadow Chess. في عام 2018 تم إعادة تصميمها لتشمل قائمة ممتعة من القطع بأنماط حركة وقدرات متوازنة ولكن فريدة وهو ما تراه اليوم.',
    paragraph3: 'رؤيتنا هي تسجيل جميع بيانات اللعب للمستخدمين للاستمرار في تطوير اللعبة للحفاظ على اللعب منعشاً وتشجيع اللعب الجديد.',
    paragraph4: 'مع مساحة البحث الضخمة لـ Zodiac والمعلومات المخفية ومواضع اللوحة الافتتاحية، نأمل في إيقاف هيمنة الذكاء الاصطناعي والحفاظ على Zodiac كلعبة للبشر!',
  },

  // Privacy Policy
  privacy: {
    title: 'سياسة الخصوصية',
    lastUpdated: 'آخر تحديث',

    introduction: {
      title: 'مقدمة',
      p1: 'مرحباً بك في Zodiac Chess ("نحن" أو "لنا" أو "خاصتنا"). نحن ملتزمون بحماية خصوصيتك وتوفير تجربة لعب آمنة وممتعة. توضح سياسة الخصوصية هذه كيفية جمع معلوماتك واستخدامها والكشف عنها وحمايتها عند استخدام موقعنا الإلكتروني ولعبتنا.',
      p2: 'باستخدام Zodiac Chess، فإنك توافق على جمع واستخدام المعلومات وفقاً لهذه السياسة. إذا كنت لا توافق على سياساتنا وممارساتنا، فلا تستخدم خدماتنا.',
      contact: 'اتصل:',
    },

    infoCollect: {
      title: 'المعلومات التي نجمعها',
      accountInfo: {
        title: '1. معلومات الحساب',
        item1: 'عنوان البريد الإلكتروني: مطلوب لإنشاء الحساب والاتصالات',
        item2: 'اسم المستخدم: اسم العرض الذي اخترته',
        item3: 'كلمة المرور: مشفرة ومخزنة بشكل آمن',
      },
      gameData: {
        title: '2. بيانات اللعبة',
        item1: 'إحصائيات اللعبة: الانتصارات، الخسائر، تصنيف ELO، تقدم مباريات التصنيف',
        item2: 'بيانات اللعب: اختيارات القطع، الحركات، الاستراتيجيات المستخدمة',
        item3: 'سجل المباريات: سجل الألعاب الملعوبة، الخصوم الذين واجهتهم',
        item4: 'المشتريات داخل اللعبة: العناصر التجميلية وحالة العضوية المميزة',
      },
      technicalData: {
        title: '3. البيانات التقنية',
        item1: 'معلومات الجهاز: نوع المتصفح، نظام التشغيل',
        item2: 'بيانات الاستخدام: الصفحات التي تمت زيارتها، الوقت المستغرق، الميزات المستخدمة',
        item3: 'التخزين المحلي: تفضيلات اللغة، إعدادات واجهة المستخدم، حالة اللعبة المؤقتة',
      },
    },

    children: {
      title: 'خصوصية الأطفال (امتثال COPPA)',
      p1: 'تم تصميم Zodiac Chess لتكون مناسبة للعائلة ومناسبة للاعبين من جميع الأعمار بما في ذلك الأطفال. نحن نتخذ احتياطات خاصة للامتثال لقانون حماية خصوصية الأطفال على الإنترنت (COPPA).',
      p2: 'للمستخدمين الذين تقل أعمارهم عن 13 عاماً: نوصي باستخدام وضع اللعب كضيف الذي لا يتطلب إنشاء حساب أو جمع بيانات. لا تتمتع الحسابات الضيف بإمكانية الوصول إلى ميزات الدردشة النصية، مما يضمن عدم تعرض الأطفال للتواصل مع الإنترنت الأوسع. إذا قام طفل بإنشاء حساب، فنحن نطلب موافقة الوالدين قبل جمع أي معلومات شخصية.',
      p3: 'نحن لا نجمع أو نستخدم أو نشارك عن عمد المعلومات الشخصية من الأطفال الذين تقل أعمارهم عن 13 عاماً دون موافقة الوالدين التي تم التحقق منها.',
      p4: 'أمان الدردشة: يتم تعطيل الدردشة النصية تلقائياً لجميع حسابات الضيف/المؤقتة. يمكن لأصحاب الحسابات القياسية تعطيل ميزة الدردشة في أي وقت من إعدادات حساباتهم.',
      parentalRights: 'الآباء لديهم الحق في:',
      right1: 'مراجعة المعلومات الشخصية لأطفالهم',
      right2: 'طلب حذف بيانات أطفالهم',
      right3: 'رفض المزيد من الجمع أو استخدام معلومات أطفالهم',
      contactUs: 'لممارسة هذه الحقوق، أو إذا كنت تعتقد أن طفلك قد قدم لنا معلومات شخصية، يرجى الاتصال بنا على الفور على contact@zodiac-chess.com',
    },

    howWeUse: {
      title: 'كيف نستخدم معلوماتك',
      item1: 'توفير وتحسين خدمات اللعبة',
      item2: 'مطابقة مع الخصوم المناسبين بناءً على مستوى المهارة',
      item3: 'تتبع التقدم والإحصائيات والإنجازات',
      item4: 'معالجة المدفوعات للعضويات المميزة والعناصر التجميلية',
      item5: 'إرسال إشعارات الخدمة المهمة والتحديثات',
      item6: 'تحليل بيانات اللعب لتحسينات توازن اللعبة والميزات',
    },

    thirdParty: {
      title: 'خدمات الطرف الثالث',
      firebase: {
        title: 'Firebase (Google)',
        description: 'نستخدم Firebase للمصادقة وتخزين قاعدة البيانات ووظائف متعدد اللاعبين. قد تجمع Firebase بيانات معينة كما هو موضح في سياسة الخصوصية الخاصة بها.',
      },
      stripe: {
        title: 'Stripe',
        description: 'نستخدم Stripe لمعالجة المدفوعات للعضويات المميزة والمشتريات داخل التطبيق. تتعامل Stripe مع جميع معلومات بطاقة الدفع - نحن لا نرى أو نخزن تفاصيل الدفع الكاملة الخاصة بك.',
      },
      netlify: {
        title: 'Netlify',
        description: 'يتم استضافة موقعنا على Netlify، والذي قد يجمع بيانات استضافة الويب القياسية مثل عناوين IP وسجلات الوصول.',
      },
      adsense: {
        title: 'Google AdSense (مستقبلي)',
        description: 'قد نعرض إعلانات من خلال Google AdSense. قد تستخدم هذه الإعلانات ملفات تعريف الارتباط للتخصيص. بالنسبة للمحتوى الموجه للأطفال، نعرض فقط إعلانات غير مخصصة للامتثال لـ COPPA.',
      },
      viewPolicy: 'عرض سياسة الخصوصية',
    },

    cookies: {
      title: 'ملفات تعريف الارتباط والتخزين المحلي',
      description: 'نستخدم تخزين المتصفح المحلي (مشابه لملفات تعريف الارتباط) لتحسين تجربتك:',
      item1: 'تفضيلات اللغة: تذكر لغتك المختارة',
      item2: 'جلسة الحساب: إبقاءك مسجلاً الدخول (يعمل مع Firebase)',
      item3: 'إعدادات اللعبة: تذكر تفضيلات واجهة المستخدم وإعدادات صندوق الرمل',
      item4: 'ملفات تعريف ارتباط الإعلانات: بموافقتك، قد تستخدم خدمات الإعلانات التابعة لجهات خارجية ملفات تعريف الارتباط لتخصيص الإعلانات',
    },

    security: {
      title: 'أمان البيانات',
      p1: 'ننفذ تدابير أمنية مناسبة لحماية معلوماتك:',
      item1: 'تشفير كلمة المرور: يتم تشفير جميع كلمات المرور باستخدام طرق معيارية في الصناعة',
      item2: 'اتصالات آمنة: تشفير HTTPS لجميع عمليات نقل البيانات',
      item3: 'قواعد أمان Firebase: ضوابط صارمة للوصول إلى قاعدة البيانات',
      p2: 'ومع ذلك، لا توجد طريقة نقل عبر الإنترنت آمنة بنسبة 100٪. بينما نسعى جاهدين لحماية بياناتك، لا يمكننا ضمان الأمان المطلق.',
    },

    retention: {
      title: 'الاحتفاظ بالبيانات',
      p1: 'نحتفظ ببياناتك على النحو التالي:',
      item1: 'الحسابات النشطة: يتم الاحتفاظ بالبيانات طالما كان حسابك نشطاً',
      item2: 'الحسابات غير النشطة: قد نحذف البيانات إذا كان حسابك غير نشط لمدة 10 سنوات',
    },

    rights: {
      title: 'حقوق الخصوصية الخاصة بك',
      description: 'اعتماداً على موقعك، قد يكون لديك الحقوق التالية:',
      access: {
        title: 'الوصول:',
        description: 'طلب نسخة من بياناتك الشخصية',
      },
      correction: {
        title: 'التصحيح:',
        description: 'طلب تصحيح البيانات',
      },
      deletion: {
        title: 'الحذف:',
        description: 'طلب حذف الحساب والبيانات',
      },
      portability: {
        title: 'قابلية نقل البيانات:',
        description: 'طلب البيانات بتنسيق محمول',
      },
      optOut: {
        title: 'إلغاء الاشتراك:',
        description: 'إلغاء الاشتراك في اتصالات التسويق',
      },
      contact: 'لممارسة هذه الحقوق، يرجى الاتصال بنا على contact@zodiac-chess.com',
    },

    international: {
      title: 'المستخدمون الدوليون',
      p1: 'تعمل Zodiac Chess من نيوزيلندا. إذا كنت تصل إلى خدماتنا من خارج نيوزيلندا، يرجى ملاحظة أن معلوماتك قد يتم نقلها وتخزينها ومعالجتها في نيوزيلندا وبلدان أخرى حيث يعمل مزودو خدماتنا.',
      p2: 'باستخدام خدماتنا، فإنك توافق على نقل معلوماتك إلى بلدان خارج بلد إقامتك، والتي قد يكون لها قوانين مختلفة لحماية البيانات.',
    },

    changes: {
      title: 'التغييرات على سياسة الخصوصية هذه',
      description: 'قد نقوم بتحديث سياسة الخصوصية هذه من وقت لآخر. سنخطرك بأي تغييرات عن طريق نشر سياسة الخصوصية الجديدة على هذه الصفحة وتحديث تاريخ "آخر تحديث". سيتم الإبلاغ عن التغييرات المادية عبر البريد الإلكتروني أو إشعار بارز على موقعنا.',
    },

    contact: {
      title: 'اتصل بنا',
      description: 'إذا كان لديك أي أسئلة أو مخاوف أو طلبات بشأن سياسة الخصوصية هذه أو ممارسات البيانات الخاصة بنا، يرجى الاتصال بنا:',
      email: 'البريد الإلكتروني:',
      company: 'الشركة:',
    },

    cookieConsent: {
      title: 'Cookie Consent & Control',
      p1: 'We believe in transparency and giving you control over your data. When you first visit Zodiac Chess, you will be presented with a cookie consent banner that allows you to choose which types of cookies you want to accept.',
      categories: {
        title: 'Cookie Categories',
        necessary: {
          title: 'Necessary Cookies',
          description: ' These cookies are essential for the website to function properly. They enable core features like authentication, game state management, and security. You cannot opt out of these cookies.',
        },
        analytics: {
          title: 'Analytics Cookies',
          description: ' These cookies help us understand how visitors interact with our website by collecting anonymous usage data through Firebase Analytics. This helps us improve the game experience.',
        },
        advertising: {
          title: 'Advertising Cookies',
          description: ' These cookies are used by Google AdSense to display personalized advertisements. Premium members never see ads, regardless of consent settings.',
        },
      },
      control: {
        title: 'How to Control Cookies',
        p1: 'You have several options to manage your cookie preferences:',
        method1: 'Cookie Banner: On your first visit, you can accept all cookies, reject optional cookies, or customize your preferences.',
        method2: 'Browser Settings: Most browsers allow you to refuse or delete cookies through their settings menu.',
        method3: 'Opt-Out Links: For advertising cookies, you can opt out of personalized ads using the links below.',
      },
      optOut: {
        title: 'Opt Out of Personalized Advertising',
        p1: 'If you would like to opt out of personalized advertising from Google and other ad networks, you can use these resources:',
        googleAds: 'Google Ad Settings - Manage Google personalized ads',
        daa: 'Digital Advertising Alliance (DAA) - Opt out of interest-based ads',
        eaa: 'European Interactive Digital Advertising Alliance (EDAA) - EU users opt-out',
      },
      moreInfo: 'For more detailed information about the cookies we use, please visit our',
      cookiePolicyLink: 'Cookie Policy',
    },
  },

  // Cookie Consent Banner
  cookieConsentBanner: {
    title: 'We Value Your Privacy',
    description: 'We use cookies to enhance your experience, analyze site usage, and show personalized ads (for free users only). You can customize your preferences at any time.',
    acceptAll: 'Accept All',
    rejectAll: 'Reject Optional',
    customize: 'Customize',
    savePreferences: 'Save Preferences',
    back: 'Back',
    necessary: 'Necessary Cookies',
    necessaryDesc: 'Required for the site to function. These cannot be disabled.',
    analytics: 'Analytics Cookies',
    analyticsDesc: 'Help us understand how you use the site to improve your experience.',
    advertising: 'Advertising Cookies',
    advertisingDesc: 'Used to show personalized ads (free users only, premium members never see ads).',
    privacyPolicy: 'Privacy Policy',
    cookiePolicy: 'Cookie Policy',
  },

  // Terms of Service
  terms: {
    title: 'شروط الخدمة',
    lastUpdated: 'آخر تحديث',
    back: 'رجوع',
    viewPrivacyPolicy: 'عرض سياسة الخصوصية',
    acknowledgment: 'باستخدامك لـ Zodiac Chess، فإنك تقر بأنك قد قرأت وفهمت ووافقت على الالتزام بشروط الخدمة هذه.',
    acceptance: {
      title: '1. قبول الشروط',
      p1: 'من خلال الوصول إلى Zodiac Chess ("الخدمة") واستخدامها، فإنك تقبل وتوافق على الالتزام بشروط الخدمة هذه. إذا كنت لا توافق على هذه الشروط، يرجى عدم استخدام الخدمة.',
      p2: 'نحتفظ بالحق في تعديل هذه الشروط في أي وقت. يعتبر استمرار استخدام الخدمة بعد التغييرات قبولاً للشروط المعدلة.',
    },
    description: {
      title: '2. وصف الخدمة',
      p1: 'Zodiac Chess هي لعبة لوحة استراتيجية عبر الإنترنت تتميز بقطع حيوانات فريدة ذات قدرات خاصة. تشمل الخدمة:',
      feature1: 'اللعب الفردي ضد خصوم الذكاء الاصطناعي',
      feature2: 'المطابقة متعددة اللاعبين واللعب التنافسي',
      feature3: 'دروس تفاعلية وموارد تعليمية',
      feature4: 'إنشاء الحساب وتتبع التقدم',
      feature5: 'ميزات الاشتراك المميز الاختيارية',
      feature6: 'خيارات التخصيص التجميلية',
    },
    accounts: {
      title: '3. حسابات المستخدمين',
      eligibility: {
        title: '3.1 الأهلية',
        p1: 'يجب أن يكون عمرك 13 عامًا على الأقل لإنشاء حساب. يمكن للمستخدمين الذين تقل أعمارهم عن 13 عامًا استخدام وضع اللعب كضيف تحت إشراف الوالدين ولكن لا يمكنهم إنشاء حسابات.',
      },
      responsibilities: {
        title: '3.2 أمان الحساب',
        p1: 'أنت مسؤول عن:',
        item1: 'الحفاظ على سرية كلمة المرور الخاصة بك',
        item2: 'جميع الأنشطة التي تحدث تحت حسابك',
        item3: 'إخطارنا فورًا بأي استخدام غير مصرح به',
        p2: 'نحن غير مسؤولين عن أي خسارة أو ضرر ناتج عن الوصول غير المصرح به إلى الحساب.',
      },
      prohibited: {
        title: '3.3 الأنشطة المحظورة',
        p1: 'لا يجوز لك:',
        item1: 'مشاركة حسابك مع الآخرين',
        item2: 'استخدام حسابات متعددة للتلاعب بالتصنيفات',
        item3: 'استخدام الروبوتات أو البرامج النصية أو الأدوات الآلية للعب الألعاب',
        item4: 'مضايقة أو إساءة أو تهديد اللاعبين الآخرين',
        item5: 'استغلال الأخطاء أو العيوب للحصول على ميزة غير عادلة',
        item6: 'الهندسة العكسية أو محاولة الوصول إلى كود المصدر الخاص بنا',
        p2: 'قد يؤدي انتهاك هذه القواعد إلى تعليق الحساب أو الحظر الدائم.',
      },
    },
    premium: {
      title: '4. الاشتراكات المميزة',
      billing: {
        title: '4.1 الفوترة',
        p1: 'تتم معالجة الاشتراكات المميزة من خلال Stripe. بشرائك اشتراكًا مميزًا، فإنك تفوضنا بخصم طريقة الدفع الخاصة بك بشكل متكرر حتى تقوم بالإلغاء.',
        p2: 'رسوم الاشتراك هي:',
        item1: 'الخطة الشهرية: يتم الخصم شهريًا في ذكرى تاريخ شرائك',
        item2: 'الخطة السنوية: يتم الخصم سنويًا في ذكرى تاريخ شرائك',
        p3: 'الأسعار قابلة للتغيير مع إشعار قبل 30 يومًا للمشتركين النشطين.',
      },
      cancellation: {
        title: '4.2 الإلغاء',
        p1: 'يمكنك إلغاء اشتراكك في أي وقت من خلال إعدادات حسابك أو بالاتصال بالدعم. يسري الإلغاء في نهاية فترة الفوترة الحالية.',
        p2: 'ستحتفظ بالميزات المميزة حتى نهاية فترتك المدفوعة، حتى بعد الإلغاء.',
      },
      refunds: {
        title: '4.3 استرداد الأموال',
        p1: 'الاشتراكات الشهرية: لا يوجد استرداد للأشهر الجزئية. يمكنك الإلغاء في أي وقت لإيقاف الرسوم المستقبلية.',
        p2: 'الاشتراكات السنوية: استرداد كامل إذا طُلب خلال 7 أيام من الشراء. بعد 7 أيام، يكون الاسترداد وفقًا لتقديرنا.',
        p3: 'المشتريات التجميلية: عادةً غير قابلة للاسترداد. اتصل بالدعم للظروف الاستثنائية.',
      },
    },
    acceptable: {
      title: '5. سياسة الاستخدام المقبول',
      p1: 'أنت توافق على استخدام Zodiac Chess بطريقة محترمة وقانونية. يشمل السلوك المحظور:',
      item1: 'الغش أو القرصنة أو استغلال آليات اللعبة',
      item2: 'المضايقة أو خطاب الكراهية أو اللغة التمييزية',
      item3: 'البريد العشوائي أو الإعلان أو الترويج',
      item4: 'مشاركة محتوى غير لائق (إذا تم تمكين الدردشة أو المحتوى الذي ينشئه المستخدم)',
      item5: 'انتحال شخصية مستخدمين آخرين أو أعضاء الفريق',
      item6: 'محاولة تعطيل أو إتلاف الخدمة',
      p2: 'نحتفظ بالحق في التحقيق في الانتهاكات واتخاذ الإجراء المناسب، بما في ذلك إنهاء الحساب والإبلاغ للسلطات إذا لزم الأمر.',
    },
    intellectual: {
      title: '6. حقوق الملكية الفكرية',
      ownership: {
        title: '6.1 محتوانا',
        p1: 'جميع محتويات اللعبة، بما في ذلك على سبيل المثال لا الحصر آليات اللعبة والأعمال الفنية والرسوم المتحركة والمؤثرات الصوتية والكود والتصميم، مملوكة لشركة Animal Chess Limited أو المرخصين لدينا.',
        p2: 'يُمنح لك ترخيص محدود وغير حصري وغير قابل للتحويل لاستخدام الخدمة لأغراض الترفيه الشخصي فقط.',
      },
      userContent: {
        title: '6.2 محتوى المستخدم',
        p1: 'بتقديم المحتوى (مثل رسائل الدردشة أو أسماء المستخدمين أو معلومات الملف الشخصي)، فإنك تمنحنا ترخيصًا عالميًا وخاليًا من حقوق الملكية لاستخدام هذا المحتوى وعرضه وتوزيعه فيما يتعلق بالخدمة.',
        p2: 'أنت تقر بأنك تملك أو لديك الحقوق اللازمة لأي محتوى تقدمه.',
      },
    },
    disclaimers: {
      title: '7. إخلاء المسؤولية وحدود المسؤولية',
      p1: 'يتم تقديم الخدمة "كما هي" دون ضمانات من أي نوع، سواء كانت صريحة أو ضمنية.',
      p2: 'نحن لا نضمن أن:',
      item1: 'ستكون الخدمة متواصلة أو خالية من الأخطاء',
      item2: 'سيتم تصحيح العيوب',
      item3: 'الخدمة خالية من الفيروسات أو المكونات الضارة',
      item4: 'ستلبي نتائج استخدام الخدمة توقعاتك',
      p3: 'إلى أقصى حد يسمح به القانون، نحن غير مسؤولين عن:',
      item5: 'أي أضرار غير مباشرة أو عرضية أو تبعية',
      item6: 'خسارة الأرباح أو البيانات أو السمعة التجارية',
      item7: 'انقطاع الخدمة أو فقدان البيانات',
      item8: 'الأضرار التي تتجاوز المبلغ الذي دفعته لنا في الأشهر الـ 12 الماضية',
    },
    privacy: {
      title: '8. الخصوصية',
      p1: 'يخضع استخدامك للخدمة أيضًا لسياسة الخصوصية الخاصة بنا، والتي توضح كيفية جمع معلوماتك الشخصية واستخدامها وحمايتها.',
      p2: 'باستخدام الخدمة، فإنك توافق على ممارسات البيانات الخاصة بنا كما هو موضح في سياسة الخصوصية.',
    },
    changes: {
      title: '9. التغييرات على الشروط',
      p1: 'نحتفظ بالحق في تعديل شروط الخدمة هذه في أي وقت. سنقوم بإخطار المستخدمين بالتغييرات الجوهرية عبر:',
      item1: 'إشعار بالبريد الإلكتروني للمستخدمين المسجلين',
      item2: 'إشعار بارز على الموقع الإلكتروني',
      item3: 'تحديث تاريخ "آخر تحديث" في أعلى هذه الصفحة',
      p2: 'يعتبر استمرار استخدامك للخدمة بعد التغييرات قبولاً للشروط المعدلة.',
    },
    governing: {
      title: '10. القانون الحاكم',
      p1: 'تخضع شروط الخدمة هذه لقوانين نيوزيلندا، بغض النظر عن مبادئ تعارض القوانين.',
      p2: 'يتم حل أي نزاعات ناشئة عن هذه الشروط أو استخدامك للخدمة في محاكم نيوزيلندا.',
    },
    contact: {
      title: '11. معلومات الاتصال',
      p1: 'للأسئلة أو المخاوف أو الدعم بخصوص شروط الخدمة هذه:',
      email: 'البريد الإلكتروني:',
      company: 'الشركة:',
      address: 'العنوان:',
    },
    severability: {
      title: '12. قابلية الفصل',
      p1: 'إذا تبين أن أي حكم من هذه الشروط غير قابل للتنفيذ أو غير صالح، فسيتم تقييد هذا الحكم أو إلغاؤه إلى الحد الأدنى الضروري، وستظل الأحكام المتبقية سارية المفعول بالكامل.',
    },
  },

  // Cookie Policy
  cookiePolicy: {
    title: 'سياسة ملفات تعريف الارتباط',
    lastUpdated: 'آخر تحديث',
    browserInstructions: {
      chrome: 'الإعدادات ← الخصوصية والأمان ← ملفات تعريف الارتباط',
      firefox: 'الإعدادات ← الخصوصية والأمان ← ملفات تعريف الارتباط وبيانات الموقع',
      safari: 'التفضيلات ← الخصوصية ← ملفات تعريف الارتباط وبيانات المواقع',
      edge: 'الإعدادات ← الخصوصية والبحث والخدمات ← ملفات تعريف الارتباط',
    },
    cookieTable: {
      name: 'اسم ملف تعريف الارتباط',
      purpose: 'الغرض',
      duration: 'المدة',
      type: 'النوع',
    },
    relatedPolicies: {
      title: 'السياسات ذات الصلة',
      description: 'لمزيد من المعلومات حول كيفية تعاملنا مع بياناتك، يرجى الاطلاع على:',
      privacy: 'سياسة الخصوصية',
      terms: 'شروط الخدمة',
    },

    introduction: {
      title: 'مقدمة',
      p1: 'توضح سياسة ملفات تعريف الارتباط هذه كيف تستخدم Zodiac Chess ("نحن" أو "لنا") ملفات تعريف الارتباط والتقنيات المماثلة عند زيارتك لموقعنا الإلكتروني.',
      p2: 'باستخدامك لموقعنا الإلكتروني، فإنك توافق على استخدامنا لملفات تعريف الارتباط وفقاً لهذه السياسة. إذا كنت لا توافق، يرجى تعطيل ملفات تعريف الارتباط في إعدادات متصفحك أو عدم استخدام موقعنا الإلكتروني.',
    },
    what: {
      title: 'ما هي ملفات تعريف الارتباط؟',
      p1: 'ملفات تعريف الارتباط هي ملفات نصية صغيرة يتم وضعها على جهازك (الكمبيوتر أو الهاتف الذكي أو الجهاز اللوحي) عند زيارتك لموقع ويب. تُستخدم على نطاق واسع لجعل المواقع تعمل بكفاءة وتقديم معلومات لأصحاب المواقع.',
      p2: 'تخدم ملفات تعريف الارتباط أغراضاً مختلفة، بما في ذلك تذكر تفضيلاتك وتحليل استخدام الموقع وتمكين ميزات معينة.',
    },
    types: {
      title: 'أنواع ملفات تعريف الارتباط التي نستخدمها',
      necessary: {
        title: '1. ملفات تعريف الارتباط الضرورية',
        description: 'هذه الملفات ضرورية لعمل الموقع بشكل صحيح. بدون هذه الملفات، لا يمكن تقديم الخدمات التي طلبتها.',
        examples: 'أمثلة:',
        item1: 'ملفات المصادقة - تحافظ على تسجيل دخولك لحسابك',
        item2: 'ملفات الأمان - تحمي من النشاط الاحتيالي',
        item3: 'ملفات الجلسة - تحافظ على حالة لعبتك أثناء الجلسة',
        item4: 'تفضيلات الموافقة على ملفات تعريف الارتباط - تذكر اختياراتك',
      },
      analytics: {
        title: '2. ملفات تعريف الارتباط التحليلية',
        description: 'تساعدنا هذه الملفات على فهم كيفية تفاعل الزوار مع موقعنا من خلال جمع معلومات مجهولة الهوية حول زيارات الصفحات والوقت المستغرق والميزات المستخدمة.',
        provider: 'المزود: Firebase Analytics (Google)',
        purpose: 'الغرض:',
        item1: 'قياس حركة المرور على الموقع وتفاعل المستخدمين',
        item2: 'تحديد الميزات والصفحات الشائعة',
        item3: 'فهم التركيبة السكانية للمستخدمين (الفئة العمرية، الموقع العام)',
        item4: 'تحسين أداء الموقع وتجربة المستخدم',
      },
      advertising: {
        title: '3. ملفات تعريف الارتباط الإعلانية',
        description: 'تُستخدم هذه الملفات لعرض إعلانات ذات صلة بك. كما تحد من عدد مرات مشاهدتك للإعلان وتساعد في قياس فعالية الحملات الإعلانية.',
        provider: 'المزود: Google AdSense',
        purpose: 'الغرض:',
        item1: 'عرض إعلانات مخصصة بناءً على اهتماماتك',
        item2: 'قياس أداء الإعلانات والتفاعل معها',
        item3: 'منع عرض نفس الإعلان مرات كثيرة',
        note: 'ملاحظة: المشتركون المميزون لا يرون الإعلانات أبداً، بغض النظر عن إعدادات ملفات تعريف الارتباط.',
      },
    },
    firstThird: {
      title: 'ملفات الطرف الأول مقابل ملفات الطرف الثالث',
      firstParty: {
        title: 'ملفات تعريف الارتباط للطرف الأول',
        description: 'هذه هي ملفات تعريف الارتباط التي يتم تعيينها مباشرة بواسطة Zodiac Chess. نستخدمها للوظائف الأساسية للموقع والمصادقة وتذكر تفضيلاتك.',
      },
      thirdParty: {
        title: 'ملفات تعريف الارتباط للطرف الثالث',
        description: 'هذه هي ملفات تعريف الارتباط التي يتم تعيينها بواسطة خدمات خارجية نستخدمها، مثل Google Analytics و Google AdSense. تخضع ملفات الطرف الثالث لسياسات الخصوصية الخاصة بهؤلاء المزودين.',
      },
    },
    specific: {
      title: 'ملفات تعريف الارتباط المحددة التي نستخدمها',
      tableHeader: 'فيما يلي قائمة مفصلة بملفات تعريف الارتباط المستخدمة على موقعنا:',
    },
    control: {
      title: 'كيفية التحكم في ملفات تعريف الارتباط',
      consent: {
        title: '1. شريط الموافقة على ملفات تعريف الارتباط',
        description: 'عند زيارتك لموقعنا لأول مرة، سترى شريط موافقة على ملفات تعريف الارتباط. يمكنك:',
        item1: 'قبول الكل - السماح بجميع ملفات تعريف الارتباط (الضرورية والتحليلية والإعلانية)',
        item2: 'رفض الاختيارية - السماح فقط بالملفات الضرورية (بدون تحليلات أو إعلانات)',
        item3: 'تخصيص - اختيار أنواع ملفات تعريف الارتباط التي تريد السماح بها بالضبط',
      },
      browser: {
        title: '2. إعدادات المتصفح',
        description: 'تتيح لك معظم متصفحات الويب التحكم في ملفات تعريف الارتباط من خلال إعداداتها. يمكنك:',
        item1: 'حظر جميع ملفات تعريف الارتباط',
        item2: 'قبول ملفات الطرف الأول فقط',
        item3: 'حذف ملفات تعريف الارتباط بعد كل جلسة تصفح',
        item4: 'عرض وحذف ملفات تعريف الارتباط الفردية',
        links: 'فيما يلي روابط لإدارة ملفات تعريف الارتباط للمتصفحات الشائعة:',
      },
      optOut: {
        title: '3. أدوات إلغاء الاشتراك',
        description: 'بالنسبة لملفات تعريف الارتباط الإعلانية تحديداً، يمكنك إلغاء الاشتراك في الإعلانات المخصصة:',
        googleLink: 'إعدادات إعلانات Google',
        googleDesc: ' - إدارة إعلانات Google المخصصة',
        daaLink: 'تحالف الإعلانات الرقمية (DAA)',
        daaDesc: ' - إلغاء الاشتراك في الإعلانات القائمة على الاهتمامات',
        edaaLink: 'التحالف الأوروبي للإعلانات الرقمية التفاعلية (EDAA)',
        edaaDesc: ' - أداة إلغاء الاشتراك الخاصة بالاتحاد الأوروبي',
      },
    },
    impact: {
      title: 'تأثير تعطيل ملفات تعريف الارتباط',
      p1: 'إذا قمت بتعطيل أو رفض ملفات تعريف الارتباط، يرجى ملاحظة أن:',
      item1: 'قد لا تعمل بعض أجزاء الموقع بشكل صحيح',
      item2: 'قد تحتاج إلى إعادة إدخال تفضيلاتك في كل زيارة',
      item3: 'قد يتم تسجيل خروجك من حسابك',
      item4: 'ملفات تعريف الارتباط الضرورية مطلوبة لعمل الموقع - تعطيلها سيمنعك من استخدام الميزات الأساسية',
    },
    updates: {
      title: 'تحديثات سياسة ملفات تعريف الارتباط',
      p1: 'قد نقوم بتحديث سياسة ملفات تعريف الارتباط هذه من وقت لآخر لتعكس التغييرات في ممارساتنا أو لأسباب قانونية أو تنظيمية أو تشغيلية.',
      p2: 'سنخطرك بالتغييرات المهمة عن طريق تحديث تاريخ "آخر تحديث" في أعلى هذه الصفحة. يرجى مراجعة هذه السياسة بشكل دوري.',
    },
    contact: {
      title: 'اتصل بنا',
      p1: 'إذا كانت لديك أسئلة حول استخدامنا لملفات تعريف الارتباط أو هذه السياسة، يرجى الاتصال بنا:',
      email: 'البريد الإلكتروني:',
      company: 'الشركة:',
    },
  },

  // Game
  game: {
    yourTurn: 'دورك',
    opponentTurn: 'دور الخصم',
    victory: 'انتصار!',
    defeat: 'هزيمة',
    draw: 'تعادل',
    resign: 'استسلام',
    offerDraw: 'عرض التعادل',
  },

  // Game End Popup
  gameEnd: {
    victory: 'انتصار!',
    defeat: 'هزيمة!',
    draw: 'تعادل!',
    wonBy: 'فوز بـ {condition}',
    lostBy: 'خسارة بـ {condition}',
    drawBy: 'تعادل بـ {condition}',
    youCapturedTheirKing: 'You captured their {piece} King!',
    yourKingWasCaptured: 'Your {piece} King was captured!',
    rematchButton: 'Rematch',
    backButton: 'Back',
    conditions: {
      kingslayer: 'قاتل الملك',
      race: 'فوز السباق',
      timeout: 'انتهاء الوقت',
      threefold: 'تكرار ثلاثي',
      noMoves: 'لا حركات متاحة',
      draw: 'تعادل',
    },
  },

  // Game Info
  gameInfo: {
    title: 'معلومات اللعبة',
    sandboxMode: 'وضع التجربة',
    lightTurn: 'دور الفاتح',
    darkTurn: 'دور الداكن',
    yourTurn: 'دورك',
    opponentTurn: 'دور الخصم',
    aiThinking: 'الذكاء الاصطناعي يفكر...',

    // Selection states
    selecting: 'اختيار {piece}',
    observing: 'مراقبة {piece}',
    selectingZombified: 'اختيار {piece} العدو المسيطر عليه',
    selectionLocked: 'الاختيار مقفل على {piece}',
    selectionLockedPenguin: 'البطريق مقفل الاختيار',

    // Hints
    clickToFaint: 'انقر على {piece} للإغماء',
    clickToRotate: 'انقر على {piece} للدوران',
    clickToInk: 'انقر على {piece} للحبر',
    zombifiedWarning: '⚠️ أثناء السيطرة، {piece} يدور قبل الحركة!',

    // Monkey bonus turn
    monkeySwing: 'القرد أكمل التأرجح، حرك قردك لإكمال الدور الإضافي',
    monkeyConsume: 'القرد أكل الفطر، حرك قردك لإكمال الدور الإضافي',

    // Virus bonus turn
    virusInfecting: 'الفيروس يصيب، استمر في الدور أو انقر على الفيروس لإنهاء الدور',

    // Penguin bonus turn
    penguinRotate: 'البطريق أكمل الانزلاق - اختر اتجاه الدوران النهائي',
    penguinCaptureRotate: 'البطريق أكمل الأسر - اختر اتجاه الدوران النهائي',
    penguinZombified: 'البطريق المسيطر عليه دار - أكمل الدور بالانزلاق/الأسر (ستنتهي السيطرة)',

    // Capture restrictions
    cannotCapture: '{piece} لا يستطيع الأسر: {targets}',
    cannotInfect: '{piece} لا يستطيع الإصابة: {targets}',
    cannotEntangle: '{piece} لا يستطيع التشابك: {targets}',
    monkeyBearRoll: '{piece} يجب أن يحصل على 5-6 لأسر {target} العدو',
    cannotBeCapturedBy: '{piece} cannot be captured by: {attackers}',
    monkeyNeedsRoll: '{attacker} needs to roll 5-6 to capture',

    // Meadow warning (Tree immobilization)
    meadowWarning: '{piece} is immobilized by enemy {fungi}',
    rhinoChargeWarning: '{piece} charge does not affect: {targets}',
    snakeStrikeWarning: '{piece} strike does not affect: {targets}',
  },

  // Piece names
  pieces: {
    Bear: 'الدب',
    Crane: 'الكركي',
    Frog: 'الضفدع',
    Fungi: 'الفطر',
    Goat: 'الماعز',
    Monkey: 'القرد',
    Octopus: 'الأخطبوط',
    Penguin: 'البطريق',
    Rhino: 'وحيد القرن',
    Snake: 'الأفعى',
    Tree: 'الشجرة',
    Virus: 'الفيروس',
    Wolf: 'الذئب',
  },

  // Short poetic vibe descriptions for landing carousel — one per variant
  pieceVibes: {
    Bear:    { light: 'Few dare approach',                   dark: 'Nothing impedes her hunger' },
    Crane:   { light: 'Sailing above, quieter than the wind',      dark: 'It circles. It waits. The lonely never return home' },
    Frog:    { light: 'Lazing on the lily pad',       dark: 'Take the colors as a warning' },
    Fungi:   { light: 'The meadow-maker',         dark: 'Consume and see who has been consumed' },
    Goat:    { light: 'Catch me on the cliff side',   dark: 'The corpse that blinks' },
    Monkey:  { light: 'Branch to branch to foe, laughing all the way',               dark: 'Roll the bones. Smiles either way' },
    Octopus: { light: 'Soft arms, razor sharp hooks, never releasing its grip',  dark: 'A bloom of black water. The shape inside is gone' },
    Penguin: { light: 'A harmless little thing in a tiny black coat',        dark: 'Slow and cute, right?' },
    Rhino:   { light: 'Waiting to face down a challenger', dark: 'Lock eyes at your peril' },
    Snake:   { light: 'Changing endings like outfits',                               dark: 'Do not tread near me' },
    Tree:    { light: 'A haven amongst the beasts',             dark: 'Standing where the dead stood. Still standing' },
    Virus:   { light: 'The battle for pandoras box',         dark: 'They feel triumph, then a cough, then silent disbelief' },
    Wolf:    { light: 'The alpha of his pack',  dark: 'When the pack is gone. What remains excites' },
  },


  // Move Context (piece descriptions)
  moveContext: {
    title: 'سياق الحركة',
    emptyState: 'اختر قدرة من اللوحة اليسرى لعرض معلومات مفصلة.',
  },

  // Challenge AI
  challengeAI: {
    // Title and tagline
    title: 'ساحة الذكاء الاصطناعي',
    tagline: 'اختر ذكاءً اصطناعياً للمواجهة أو شاهد الذكاء الاصطناعي يتنافس!',

    // Player labels
    lightPlayer: 'اللاعب الفاتح',
    darkPlayer: 'اللاعب الداكن',
    humanPlayer: 'لاعب بشري',
    aiPlayer: 'AI',
    difficulty: 'Difficulty',
    difficultyEasy: 'Easy',
    difficultyMedium: 'Medium',
    difficultyHard: 'Hard',

    // AI Models
    aiGaia: 'Gaia',
    aiSentinel: 'الحارس',
    aiAlchemist: 'الخيميائي',
    aiZenith: 'الذروة',
    aiTrapper: 'الصياد',
    aiHunter: 'القناص',
    aiWisp: 'الشبح',
    aiCreature: 'Creature',
    aiWeaver: 'النساج',

    // Time Frames
    timeFast: 'سريع',
    timeStandard: 'عادي',
    timeDeep: 'عميق',

    // Thinking time
    thinkingTime: 'وقت التفكير',

    // Info box
    matchupLabel: 'المواجهة:',
    statusLabel: 'الحالة:',
    statusPaused: 'متوقف',
    statusAIThinking: 'الذكاء الاصطناعي يفكر...',
    statusInGame: 'في اللعبة',
    statusReady: 'جاهز',
    matchupLocal2P: 'لاعبان محلياً',
    matchupPlayerVs: 'لاعب ضد',
    matchupVsPlayer: 'ضد لاعب',

    // Buttons
    startButton: 'ابدأ',
    startRandomButton: 'ابدأ عشوائياً',
    newGameButton: 'لعبة جديدة',
    resumeButton: 'استئناف',
    pauseButton: 'إيقاف',
    pauseQueuedButton: 'إيقاف (في الانتظار...)',
    viewKingsButton: 'عرض الملوك',
    hideKingsButton: 'إخفاء الملوك',
    viewKingsQueuedButton: 'عرض الملوك (في الانتظار...)',
    hideKingsQueuedButton: 'إخفاء الملوك (في الانتظار...)',
    homeButton: 'الرئيسية',
    toggleKingVisibility: 'تبديل رؤية الملك',

    // Warning modal
    invalidPlacement: 'وضع غير صالح',
    okButton: 'موافق',
    warningLightTurn: 'دور اللاعب الفاتح لوضع قطعة!',
    warningDarkTurn: 'دور اللاعب الداكن لوضع قطعة!',
    warningLightRow: 'يجب وضع القطع الفاتحة في الصف 0 (صفك الأصلي)!',
    warningDarkRow: 'يجب وضع القطع الداكنة في الصف 7 (صفك الأصلي)!',
    warningOccupied: 'هذا المربع مشغول بالفعل! اختر مربعاً فارغاً.',
    warningKingRequired: 'يجب وضع ملكك ({kingType}) قبل وضع القطعة الخامسة!',

    // Piece selection
    dragPieces: 'اسحب القطع إلى اللوحة',
    lightPieces: 'القطع الفاتحة',
    darkPieces: 'القطع الداكنة',

    // Mobile
    selectYourKing: 'اختر ملكك',
    selectPieceToPlace: 'اختر قطعة للوضع',
    moveHistory: 'سجل الحركات',
    historyButton: 'السجل',
    backButton: 'رجوع',
    lightTurn: 'دور الفاتح',
    darkTurn: 'دور الداكن',
  },

  // Upgrade Modal
  upgrade: {
    title: 'الترقية إلى بريميوم',
    accountRequired: 'تحتاج إلى إنشاء حساب دائم قبل الترقية إلى بريميوم.',
    createAccountPrompt: 'أنشئ حساباً لحفظ تقدمك وفتح ميزات بريميوم!',
    subtitle: 'افتح ميزات قوية لتعزيز تجربتك في Zodiac Chess!',
    features: {
      history: 'سجل الحساب',
      historyItem1: 'خزن واسترجع جميع ألعابك السابقة',
      historyItem2: 'أعد تشغيل ألعابك القديمة من أي نقطة لتقييم الاستراتيجية',
      historyItem3: 'استخدم التحليلات العميقة لتحليل مواقع اللوحة وفرص الحركات الرائعة',
      analytics: 'التحليلات',
      analyticsItem1: 'احصل على إحصائيات اللعبة',
      analyticsItem2: 'حلل اختيارات اللاعبين للقطع والملوك عبر مقاييس متعددة',
      analyticsItem3: 'اكتشف الاستراتيجيات الشائعة وما ينجح!',
      course: 'الدورات',
      courseItem1: 'احصل على دورات محدثة لتطوير مهاراتك',
      courseItem2: 'تعلم الاستراتيجيات والمفاهيم من المحترفين',
      courseItem3: 'احصل على نصائح حول لعبك لتحليل نقاط ضعفك',
    },
    createAccount: 'إنشاء حساب',
    upgradeNow: 'الترقية الآن',
    cancel: 'إلغاء',
  },

  // Premium Modal
  premium: {
    title: 'ميزة بريميوم',
    accessDenied: 'عذراً، ليس لديك حساب بريميوم، لا يمكنك الوصول إلى هذه الميزات بعد!',
  },

  // Donation
  donation: {
    title: 'ادعم Zodiac Chess',
    supportDevelopment: 'ادعم التطوير',
    story1: 'مرحباً! دعمك يساعدني في مواصلة تحسين هذه اللعبة الفريدة! إضافة ميزات جديدة، صيانة الخوادم، والحفاظ على Zodiac Chess مجانية للمجتمع.',
    story2: 'حتى التبرع الصغير يحدث فرقاً كبيراً ويبقي هذا المشروع حياً. شكراً لكونك جزءاً من رحلة Zodiac Chess :)',
    selectAmount: 'اختر المبلغ',
    customAmount: 'أو أدخل مبلغاً مخصصاً:',
    total: 'الإجمالي:',
    donateButton: 'تبرع الآن',
    processing: 'جاري المعالجة...',
    disclaimer: 'التبرعات تدعم التطوير وتكاليف الخوادم. شكراً لكرمك!',
    invalidAmount: 'يرجى إدخال مبلغ صالح أكبر من $0',
    error: 'حدث خطأ في معالجة تبرعك. يرجى المحاولة مرة أخرى.',
  },

  // Stripe Error Page
  stripe: {
    errorTitle: 'عذراً! حدث خطأ ما',
    errorMessage: 'واجهنا مشكلة في معالجة دفعتك. لا تقلق، لم يتم خصم أي مبلغ.',
    whatHappened: 'ماذا حدث؟',
    notCompleted: 'لم تكتمل دفعتك. قد يكون ذلك بسبب:',
    reasons: {
      cancelled: 'تم إلغاء الدفع',
      declined: 'تم رفض البطاقة',
      connection: 'مشكلة في الاتصال أثناء الدفع',
      expired: 'انتهت صلاحية الجلسة',
    },
    whatToDo: 'ماذا يمكنك أن تفعل؟',
    actions: {
      tryDifferentCard: 'حاول مرة أخرى ببطاقة مختلفة',
      tryDifferentCardDesc: 'استخدم طريقة دفع أخرى',
      retryPayment: 'أعد محاولة الدفع',
      retryPaymentDesc: 'أحياناً المحاولة البسيطة تنجح',
      checkBank: 'تحقق من بنكك',
      checkBankDesc: 'تأكد من وجود رصيد كافٍ في بطاقتك',
    },
    tryAgain: 'حاول الترقية مرة أخرى',
    returnHome: 'العودة إلى الصفحة الرئيسية',
    contactSupport: 'تحتاج مساعدة؟ تواصل مع الدعم على support@zodiac-chess.com',
  },


  // How To Play - Learn the Pieces
  howToPlay: {
    // Section titles
    whatIsZodiac: 'ما هي اللعبة؟',
    gameSetup: 'إعداد اللعبة',
    basicRules: 'القواعد الأساسية',
    backButton: 'رجوع',
    homeButton: 'الرئيسية',
    fullRules: 'القواعد الكاملة',

    // What is Zodiac section
    whatIs: {
      p1: 'Zodiac هي لعبة استراتيجية مجردة للاعبين اثنين مستوحاة من الشطرنج والبوكر وDotA.',
      p2: 'تم إنشاؤها في 2014 كنسخة بدائية تسمى "شطرنج الظل" بناءً على مبدأها الأساسي وهو الملك السري',
      p3: 'لاحقاً في 2018 أعيد تصميمها لتشمل مجموعة من القطع الجديدة بأنماط حركة وقدرات فريدة',
      p4: 'هدف Zodiac هو الاحتفاء بالحدس البشري واللعب المبتكر. لتوجيه النجاح نحو قدرة اللاعب على الخداع والتكيف مع المواقف غير المألوفة وخلق مجموعة متنوعة من التحديات للقوة المتنامية للذكاء الاصطناعي',
      p5: 'هدف آخر لـ Zodiac هو أن تكون لعبة للبشر! مع مساحة بحث كبيرة جداً للعب، ومعلومات مخفية، وإخفاء الفوز، ومجموعة متغيرة من القطع بمرور الوقت. تريد Zodiac أن تكون لعبة مدفوعة ببيانات اللاعبين تحافظ على الإبداع وتصد هيمنة الذكاء الاصطناعي',
      p6: 'نأمل أن تبقى معنا وترى إلى أين تأخذنا هذه الرحلة',
    },

    // Setup section
    setup: {
      p1: 'يلعب اللاعبون نسخة Zodiac من حجر ورق مقص لتحديد من يبدأ أولاً!',
      p2: 'من هناك، اختر قطعة لتكون "ملكك" خصمك لن يعرف أي قطعة اخترت.',
      p3: 'ثم اختر 5 قطع للعب بها، جميعها لها قدرات وتناغم ونقاط قوة وضعف مختلفة!',
      p4: 'بمجرد انتهائكما ستبدأ اللعبة.',
      p5: 'ببساطة انقر على قطعة لترى أين يمكنها التحرك أو انقر على أي مربع غير مضاء لإلغاء اختيار القطعة.',
      p6: 'حظاً موفقاً!',
    },

    // Basic Rules section
    rules: {
      intro: 'تُلعب لعبة Zodiac بين لاعبين على لوحة مستطيلة مكونة من 40 مربعاً (5 × 8).',
      toWinTitle: 'للفوز:',
      toWin1: 'أسر ملك الخصم',
      toWin2: '"سباق" ملكك عبر اللوحة',
      toWin3: 'انتهاء مؤقت خصمك',
      toWin4: 'استسلام خصمك',
      drawTitle: 'يحدث التعادل',
      draw1: 'عندما يكون ملك اللاعب لم يُؤسر ولا يستطيع القيام بأي حركة قانونية، أو؛',
      draw2: 'تكرار نفس وضعية اللوحة ثلاث مرات',
    },

    // Piece tutorials
    tutorials: {
      bear: {
        desc1: 'الحركة العادية - يمكن للدب التحرك مربعاً واحداً في أي اتجاه',
        desc2: 'قدرة الدب "الوحشي" تسمح له بأسر أي قطعة بغض النظر عن القدرات الدفاعية',
        desc3: 'الدب قطعة "كبيرة" و"مفترسة" مما يعني أن العديد من قطع Zodiac الأخرى لا تستطيع أسره!',
      },
      crane: {
        desc1: 'يمكن للكركي التحرك 1 أو 2 في أي خط مستقيم لحركته العادية',
        desc2: 'الكركي لا يستطيع أسر أي قطع "كبيرة" أو "مفترسة"',
      },
      frog: {
        desc1: 'يمكن للضفدع القفز 2 على الأقطار لحركته العادية، حتى فوق القطع الأخرى!',
        desc2: 'إذا كانت حركة الضفدع العادية محجوبة بجدار أو قطعة لا يستطيع أسرها، تقصر حركته العادية إلى مربع واحد قطرياً',
        desc3: 'إذا لم يقم الضفدع بأي حركة في اللعبة بعد، فهو على "زنبقته" ويمكنه التحرك إلى أي من الصفوف الثلاثة الأولى كحركة دفاعية',
        desc4: 'إذا أسرت قطعة ضفدعاً، تصبح مسمومة ولا تستطيع القيام بأي حركة في دورها التالي',
        desc5: 'حركة الضفدع الخاصة هي "تسلق الجدار" إذا كان الضفدع بجانب حافة اللوحة، يمكنه أيضاً التحرك واحداً للأعلى أو للأسفل',
      },
      fungi: {
        desc1: 'يمكن للفطر التحرك واحداً في أي اتجاه لحركته العادية',
        desc2: 'قدرة الفطر "المرج" تمنع الشجرة من التحرك إذا كانت ضمن مربع واحد من الفطر ولا تسمح للشجرة بالتحرك ضمن مربع واحد من فطر العدو',
        desc3: 'عند الأسر يطبق الفطر تأثير "الزومبي" على أي قطعة حيوانية أسرته',
        desc4: 'أثناء التحول للزومبي، يتحكم الفطر بالقطعة في الدور التالي ويتصرف كالقطعة، مما يعني إذا كان الفطر ملكك، لا يزال بإمكانك الفوز بفوز السباق أو أسر ملك العدو في تلك الجولة',
      },
      goat: {
        desc1: 'يمكن للماعز التحرك واحداً في أي اتجاه لحركته العادية',
        desc2: 'قدرة الماعز "العبور" تسمح لها بالقفز عبر القطع المرتبطة ثم التحرك، لا تستطيع أسر أي قطعة أثناء العبور',
        desc3: 'الماعز لا تستطيع أسر أي "مفترسين"',
        desc4: 'يمكن للماعز استخدام قدرة خاصة تسمى "الإغماء" لتظهر ميتة',
        desc5: 'أثناء الإغماء، لا يمكن أسر الماعز من معظم القطع لكن لا تستطيع التحرك إذا كانت قطعة أخرى "واقفة" عليها (في نفس المربع)',
      },
      monkey: {
        desc1: 'يمكن للقرد التحرك واحداً في أي اتجاه لحركته العادية',
        desc2: 'يمكن للقرد "القفز" فوق القطع الصديقة والعدوة مثل قطعة الداما إذا سمح التشكيل',
        desc3: 'إذا قفز القرد فوق قطعة عدوة يجب أن يرمي نردا لتجنب الأسر! نقطة خطر واحدة لكل قطعة عدوة يقفز فوقها في خط واحد',
        desc4: 'القرد يستطيع أسر الدب إذا قرر المقامرة لمهاجمته، برمية 1-4 على نرد سداسي يُؤسر القرد، برمية 5 أو 6 يأسر القرد الدب',
        desc5: 'للقرد قدرتان - "التأرجح" و"الاستهلاك" في التأرجح (قفزة تنتهي فوق شجرة) يكسب القرد حركة إضافية، في استهلاك أي فطر يكسب القرد أيضاً حركة إضافية قبل انتهاء دوره',
      },
      octopus: {
        desc1: 'يمكن للأخطبوط التحرك واحداً في أي اتجاه لحركته العادية',
        desc2: 'الأخطبوط يستطيع الأسر فقط على المربعات العمودية',
        desc3: 'يمكن للأخطبوط استخدام قدرته "التشابك" على أي قطعة حيوانية على المربعات القطرية',
        desc4: 'يمكن للأخطبوط القيام بأي حركة والتشابك في دور واحد',
        desc5: 'للأخطبوط قدرة تسمى "الحبر" بهذه القدرة يمكنه التحرك إلى أي مربع عمودي ووضع "ظلال" على المربعات العمودية الثلاثة الأخرى إذا لم تكن مشغولة أو خارج اللوحة. للخصم في الجولة التالية لقدرة "الحبر" لا يمكن تمييز الظلال والأخطبوط الحقيقي',
      },
      penguin: {
        desc1: 'للبطريق قدرة تسمى "الدوران" وهو القطعة الوحيدة التي لها اتجاه محدد ويمكنها استخدام حركة "الدوران" لإعادة توجيه اتجاهها في دورها',
        desc2: 'لحركة البطريق العادية "الانزلاق" يجب أن يتحرك إلى أبعد نقطة في الاتجاه الذي يواجهه وبمجرد وصوله هناك يمكنه استخدام الدوران قبل انتهاء دوره لإعادة توجيه اتجاهه',
        desc3: 'البطريق لا يستطيع أسر أي قطع "كبيرة" أو "مفترسة". يمكنه أسر أي قطعة أخرى ضمن مربع واحد منه واستخدام قدرة الدوران بعد الأسر',
      },
      rhino: {
        desc1: 'يمكن لوحيد القرن التحرك "خلف يسار"، "خلف يمين" أو اثنين للأمام كجزء من حركته العادية',
        desc2: 'لوحيد القرن قدرة تسمى "الدوس" حيث يأسر جميع القطع في مسار حركته',
        desc3: 'مرة واحدة في اللعبة يمكن لوحيد القرن تنفيذ شحنة 3 مربعات للأمام إذا كان أي حيوان موجوداً في أي من المربعات الثلاثة أمام وحيد القرن مباشرة',
        desc4: 'لوحيد القرن قدرة خاصة تسمى "دفاع وحيد القرن" حيث لا يمكن أسر وحيد القرن من "الأمام"',
        desc5: 'لوحيد القرن قدرة تسمى "الممر" حيث إذا لم يتحرك والقطعة الصديقة مباشرة على يساره أو يمينه لم تتحرك، يمكنه تبديل الأماكن مع تلك القطعة في دوره',
      },
      snake: {
        desc1: 'يمكن للأفعى التحرك مربعين فقط في الاتجاهات العمودية، بما في ذلك عبر القطع الأخرى لحركتها العادية',
        desc2: 'إذا كانت حركتها العادية محجوبة بجدار أو قطعة لا تستطيع أسرها، تصبح حركتها العادية 1',
        desc3: 'للأفعى قدرة تسمى "الضربة" حيث إذا كان حيوان على بعد 3 مربعات بالضبط أمامها ولا توجد قطع بينهما، يمكنها "الضرب" للأمام وأسر ذلك الحيوان',
        desc4: 'للأفعى قدرة تسمى "الانسلاخ" حيث مرة واحدة في اللعبة إذا أُسرت الأفعى، ستعود إلى الصف الأول من اللوحة، في نفس العمود، كأن لها حياة ثانية. إذا لم يكن الصف الأول مربعاً صالحاً للأفعى للتحرك إليه، تُؤسر نهائياً',
      },
      tree: {
        desc1: 'يمكن للشجرة التحرك واحداً للأمام أو بلا حدود جانبياً إذا لم تكن محجوبة بأي قطعة أخرى',
        desc2: 'للشجرة قدرة خاصة تسمى "الإيواء" حيث أي قطعة تستطيع "تسلق" الأشجار يمكنها الجلوس فوق قطعة الشجرة. إذا هاجمت قطعة عدوة شجرة بها قطعة محتضنة، تُؤسر القطعة المحتضنة وتحتضن الشجرة قطعة العدو',
        desc3: 'عندما تكون قطعة محتضنة في الشجرة، إذا كانت قطعة عدوة لا تستطيع تسلق الشجرة، تكون كل من الشجرة والقطعة المحتضنة محمية من الأسر',
      },
      wolf: {
        desc1: 'يتحرك الذئب بشكل حرف L مثل الحصان في الشطرنج لحركته العادية',
        desc2: 'إذا كان الذئب آخر قطعة على اللوحة* تُفعّل قدرته "الذئب الوحيد" ويتحرك بحرف L طويل بدلاً كما هو موضح أعلاه. *سيدخل الذئب وضع الوحيد إذا كان في فريق مع ماعز مغشي عليها أو فيروس معدي',
      },
      virus: {
        desc1: 'يمكن للفيروس التحرك مربعين في أي خط مستقيم لحركته العادية، لا يأسر لكن يستخدم قدرته "العدوى" لجعل القطعة مصابة بدلاً من أسرها',
        desc2: 'يمكن للفيروس التحرك فقط إلى أي قطعة حيوانية، إذا كان محجوباً بجدار، تصبح حركة الفيروس العادية مربعاً واحداً فقط',
        desc3: 'عندما تكون قطعة حيوانية "مصابة" إذا غادر الفيروس القطعة المصابة إلى قطعة أخرى، تُؤسر القطعة التي غادرها والقطعة الجديدة تصبح "مصابة"',
        desc4: 'للفيروس قدرة تسمى "معدي" تسمح للفيروس بإكمال العديد من الحركات الصالحة في حركة واحدة كما يشاء، أسر عدة حيوانات في دور واحد',
        desc5: 'بينما لا يكون "يعدي" يمكن أسر الفيروس مثل أي قطعة أخرى، إذا أسر حيوان قطعة مصابة، يصبح مصاباً',
      },
    },
  },
};
